<template>
  <v-container
    id="dashboard"
    fluid
    tag="section"
  >
    <v-row>
      <v-col>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          color="primary"
        />
      </v-col>
    </v-row>
    <sequential-entrance from-top>
      <v-row>
        <v-col
          sm="12"
          md="12"
          lg="12"
        >
          <base-material-card
            v-if="!loading"
            color="primary"
            icon="mdi-map-marker-radius"
            inline
            title="Device Reports"
          >
            <v-col cols="12">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              />
            </v-col>
            <v-spacer />
            <v-row>
              <v-spacer />

              <download-csv
                :name="csvfilename()"
                :data="getlocs"
              >
                <v-btn color="info">
                  <v-icon
                    color="white"
                    left
                  >
                    mdi-arrow-down
                  </v-icon>CSV
                </v-btn>
              </download-csv>
            </v-row>
            <v-data-table
              :headers="locationHeaders"
              :items="getlocs"
              :items-per-page="itemsPerPage"
              :page.sync="page"
              sort-by="rejcount"
              sort-desc
              :search="search"
              @page-count="pageCount = $event"
            >
              <template v-slot:item.notereader="{ item }">
                <v-btn
                  fab
                  small
                  color="deep-purple darken-1"
                  :to="'/ReportNotereader/' + item.idnum"
                  dark
                >
                  <v-icon dark>
                    mdi-cash-multiple
                  </v-icon>
                </v-btn>
              </template>
              <template v-slot:item.version="{ item }">
                <v-btn
                  fab
                  small
                  color="orange darken-1"
                  :to="'/ReportVersions/' + item.idnum"
                  dark
                >
                  <v-icon dark>
                    mdi-format-list-bulleted-square
                  </v-icon>
                </v-btn>
              </template>
            </v-data-table>
            <div class="text-center pt-2">
              <v-pagination
                v-model="page"
                :length="pageCount"
              />
            </div>
          </base-material-card>
        </v-col>
      </v-row>
    </sequential-entrance>
  </v-container>
</template>

<script>
  import moment from 'moment'

  export default {

    name: 'Locations',

    data () {
      return {
        search: '',
        loading: false,
        page: 1,
        pageCount: 0,
        itemsPerPage: 10,
        chartOptions: {
          chart: {
            id: 'vuechart-example'
          },
          xaxis: {
            categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998]
          }
        },
        series: [{
          name: 'series-1',
          data: [30, 40, 35, 50, 49, 60, 70, 91]
        }],
        sites: this.$store.getters.loadedSites,
        profiles: this.$store.getters.loadedSiteProfiles,
        locations: [],
        locationHeaders: [
          {
            sortable: true,
            text: 'Sites ID',
            value: 'idnum',
            width: 200
          },
          {
            sortable: true,
            text: 'Group',
            value: 'group',
          },
          {
            sortable: true,
            text: 'Status',
            value: 'status'
          },
          {
            sortable: true,
            text: 'Ver',
            value: 'sv'
          },
          {
            sortable: true,
            text: 'Note Reader',
            value: 'nv'
          },
          {
            sortable: true,
            text: 'Note Jams Today',
            value: 'jamcount',
            align: 'center'
          },
          {
            sortable: true,
            text: 'Note Rejections Today',
            value: 'rejcount',
            align: 'center'
          },
          {
            sortable: false,
            text: 'Note Reader Report',
            value: 'notereader',
            align: 'center'
          },
          {
            sortable: false,
            text: 'Site Report',
            value: 'version',
            align: 'center'
          }
        ],
        icons: true,
        centered: true,
        newtab: null,
        activeBtn: 1,
        grow: true,
        tab: null,
        tabs: 0,
      }
    },
    computed: {
      totalSales () {
        return this.sales.reduce((acc, val) => acc + val.salesInM, 0)
      },
      getlocs () {
        this.locations = []
        let today = moment().format('YYYY-MM-DD')

        let eventlist = this.$store.getters.notereaderevents
        let jamlist = this.$store.getters.notereaderjams
        for (let [key, value] of Object.entries(this.$store.getters.loadedSiteProfiles)) {
          let name = 'Unknown'
          let group = 'NA'

          let loc = this.$store.getters.loadedSites.find(function (site) {
            if (site.idnum === key) {
              return site
            }
          })
          if (loc) {
            name = loc.sitename
            group = loc.group
          }
          if (value.siteunitsprofile) {
            let rejcount = 0
            let jamcount = 0
            let safeid = Object.values(value.siteunitsprofile)[0].crypto_idnum
            let events = eventlist.filter(event => event.crypto_idnum === safeid)
            let jams = jamlist.filter(event => event.crypto_idnum === safeid)
            let sv = 'NA'
            let nv = 'NA'
            if (events.length > 0) {
              let todaysevents = events.filter(event => event.day === today)
              let todaysjams = jams.filter(jam => jam.day === today)
              if (todaysjams.length > 0) {
                jamcount = todaysjams[0].jamcount
              }

              if (todaysevents.length > 0) {
                rejcount = todaysevents[0].rejcount
                // this.$log.debug('count is ', todaysevents[0].rejcount)
              }
              //
            }

            let rec = this.$store.getters.getheartbeatvalues.find(element => element.crypto_idnum === safeid)
            console.log('heartbeat val ', rec)
            let status = 'N/A'
            if (rec) {
              sv = rec.version
              nv = rec.notereaderversion
              let now = Date.now()
              let delta = (now - rec.heartbeat)
              // this.lastheartbeat = moment(rec.heartbeat)
              // this.$log.debug('last heartbeat ', this.lastheartbeat)
              if (delta <= 3600000) {
                status = 'Online'
              }
              if (delta >= 3600000) { // 60  minutes
                status = 'Offline'
              }
            }
            if (!safeid.includes('Postal') && !safeid.includes('Virtual')) {
              let shop = {
                idnum: key,
                group: group,
                safeid: safeid,
                status: status,
                sv: sv,
                nv: nv,
                jamcount: jamcount,
                rejcount: rejcount,
                sitename: name
              }
              this.locations.push(shop)
            }
          }
          // this.$log.debug(key,value.siteunitsprofile)
        }
        this.$log.debug('our location map ', this.locations)
        return this.locations
      }
    },
    watch: {
      loading (val) {
        if (!val) return

        setTimeout(() => (this.loading = false), 1000)
      }
    },
    created () {
      this.loading = true
      this.$store.dispatch('loadheartbeats')

      this.$store.dispatch('loadunits')
      this.$store.dispatch('loadsiteProfiles')
      this.$store.dispatch('loadUserGroups')
      this.$store.dispatch('loadSiteConfigs')
      this.$store.dispatch('loadnotereaderevents')
      this.$store.dispatch('loadnotereaderjams')

      // let j = Object.keys(loadedprofiles)
      // let units = loadedprofiles[j[0]].siteunitsprofile
    },
    methods: {
      device_data () {
        return this.locations
      },
      csvfilename () {
        let today = moment().format('YYYY-MM-DD')
        let filename = today + '_devices' + '.csv'
        this.$log.debug('file name ', filename)
        return filename
      },
      sitestatus (ssid) {
        this.$log.debug('SSID PASSED ', ssid)
        let crypto_idnum = this.$store.getters.loadedSiteProfiles[ssid].siteunitsprofile[0].crypto_idnum
        let rec = this.$store.getters.getheartbeatvalues.find(element => element.crypto_idnum === crypto_idnum)
        let color
        if (rec) {
          let now = Date.now()
          let delta = (now - rec.heartbeat)
          let mContact = moment(rec.heartbeat)
          let mNow = moment(now)
          let duration = moment.duration(mNow.diff(mContact))
          this.$log.debug('minutes since last contact', duration.asMinutes())
          let MINUTES_CONSIDERED_OFFLINE = 60
          // this.lastheartbeat = moment(rec.heartbeat)
          // this.$log.debug('last heartbeat ', this.lastheartbeat)
          if (duration.asMinutes() <= MINUTES_CONSIDERED_OFFLINE) {
            color = 'Online'
          }
          if (duration.asMinutes() >= MINUTES_CONSIDERED_OFFLINE) { // 60  minutes
            color = 'Offline'
          }
          return color
        }
        return 'N/A'
      },
      getsitelabel (ssid) {
        // return ssid
        let label = 'unknown'
        // get list of sites in the system
        this.$store.getters.loadedSites.filter(function (site) {
          if (site.idnum === ssid) {
            label = site.sitename
          }
        })
        return label
        // loop thru, find name
        // return sitename
      },
      complete (index) {
        this.list[index] = !this.list[index]
      }
    }
  }
</script>
